import React from "react";
import VemaWebsite from "./VemaWebsite";

function App() {
  return <VemaWebsite />;
}

export default App;
